module.exports = "\r\n\r\n\r\n<app-navbar></app-navbar>\r\n\r\n<router-outlet></router-outlet>\r\n\r\n\r\n<app-footer></app-footer>\r\n\r\n\r\n"